<template>
  <a-modal :width="1300" :visible="visible" :confirmLoading="confirmLoading" @cancel="handleCancel">
    <div slot="title">
      <a-row :gutter="24">
        <!-- <a-col :span="4"> -->
        <a-avatar icon="user" :src="info.wx_avatar" /> {{ info.nickname }}数据转移
        <a href="http://zjzd.nianchu.net/?categoryId=28&sequence=0" target="blank">《NianchuCloud数据转移》</a>
        <!-- </a-col> -->
      </a-row>
    </div>
    <a-alert style="margin-bottom: 10px" message="数据来源格式为excel表格时，不要使用WPS打开，否则将会转移失败！"></a-alert>
    <a-spin :spinning="confirmLoading">
      <a-form>
        <div>
          <a-form-item label="友商数据来源" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-radio-group v-model="params.operator" @change="(e) => changeParams('operator', e.target.value)">
              <a-radio v-for="item in operator" :key="item.status" :value="item.status">
                {{ item.name }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="迁移进度" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="params.operator === 1">
            <a-steps :current="current" :size="'small'">
              <a-step v-for="item in steps" :key="item.title" :title="item.title" />
            </a-steps>
          </a-form-item>
          <!-- 速推客步骤 -->
          <a-form-item label="迁移进度" :labelCol="labelCol" :wrapperCol="{xs: { span: 24 },sm: { span: 8 }}" v-if="params.operator === 3">
            <a-steps :current="current" :size="'small'">
              <a-step v-for="item in stksteps" :key="item.title" :title="item.title" />
            </a-steps>
          </a-form-item>
          <a-form-item
            label="是否筛选机器人账户"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            v-if="params.operator === 1"
          >
            <a-radio-group v-model="params.select" @change="(e) => changeParams('select', e.target.value)">
              <a-radio :value="2"> 是 </a-radio>
              <a-radio :value="1"> 否 </a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="上传文件" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <div class="steps-content">
              <a-alert v-if="params.operator === 3" type="warning" show-icon message="需上传两个文件， 进度一上传积分.db文件，进度二上传订单.db文件" style="margin-bottom:5px;"/>
              <div class="table-operator">
                <a-upload
                  :customRequest="beforeUpload"
                  :accept="type.accept"
                  :multiple="false"
                  :file-list="fileList"
                  @change="handleChange"
                >
                  <a-button style="margin-right: 10px"> <a-icon type="upload" /> 点击上传 </a-button>
                </a-upload>
                <div style="line-height: 40px">
                  <a-button type="primary" @click="handleRefresh">刷新状态</a-button>
                </div>
              </div>
              <s-table
                ref="table"
                size="default"
                rowKey="id"
                :columns="columns"
                :data="loadData"
                :scroll="{ x: 650 }"
                :alert="options.alert"
                :rowSelection="options.rowSelection"
              >
                <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
                <span slot="file_name" slot-scope="text, record">
                  {{ record.file_name }}
                </span>
                <span slot="status_desc" slot-scope="text, record">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>{{ text }}</span>
                    </template>
                    <span v-line-clamp="1">{{ text }}</span>
                  </a-tooltip>
                </span>
                <span slot="err_msg" slot-scope="text, record">
                  <ellipsis :length="50" tooltip>
                    {{ record.err_msg }}
                  </ellipsis>
                </span>
                <span slot="status" slot-scope="text, record">
                  <a-badge v-if="record.status == 0" status="warning" :text="record.status | getItemStatus" />
                  <a-badge v-else-if="record.status == 1" status="processing" :text="record.status | getItemStatus" />
                  <a-badge v-else-if="record.status == 2" status="success" :text="record.status | getItemStatus" />
                  <a-badge v-else-if="record.status == '-1'" status="error" :text="record.status | getItemStatus" />
                  <a-badge v-else status="error" :text="record.status | getItemStatus" />
                </span>
                <span slot="actions" slot-scope="text, record">
                  <a-button type="link" :disabled="record.status == 1" @click="del(record.id)">删除数据</a-button>
                </span>
              </s-table>
            </div>
          </a-form-item>
        </div>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol">
        <div class="steps-action">
          <span v-if="params.operator !== 2">
            <a-button v-if="current > 0" style="margin-left: 8px" @click="prev"> 上一步 </a-button>
            <a-button v-if="params.operator !== 3 ? current < steps.length - 1 : current < stksteps.length - 1" :disabled="isDone" type="primary" @click="next">
              下一步
            </a-button>
          </span>

          <a-button type="primary" @click="handleSubmit" style="margin-left: 8px"> 执行转移 </a-button>
        </div>
      </a-form-item>
    </template>
  </a-modal>
</template>

<script>
import DeviceApi from '@/api/device'
import { STable } from '@/components'
import { bigFileUpload } from '@/utils/oss'
import Ellipsis from '@/components/Ellipsis'

const steps = [
  {
    title: '转移会员数据',
  },
  {
    title: '转移淘宝数据',
  },
  {
    title: '转移拼多多数据',
  },
  {
    title: '转移京东数据',
  },
  {
    title: '转移唯品会数据',
  },
]
const stksteps = [
  {
    title: '转移积分数据',
  },
  {
    title: '转移订单数据',
  },
]
const columns = [
  {
    title: '文件名称',
    scopedSlots: { customRender: 'file_name' },
    width: 120,
  },
  {
    title: '状态',
    scopedSlots: { customRender: 'status' },
    width: 80,
  },
  {
    title: '进行项',
    dataIndex: 'status_desc',
    scopedSlots: { customRender: 'status_desc' },
    width: 180,
  },
  {
    title: '错误信息',
    dataIndex: 'err_msg',
    scopedSlots: { customRender: 'err_msg' },
    width: 200,
  },
  {
    title: '操作',
    fixed: 'right',
    scopedSlots: { customRender: 'actions' },
    width: 80,
  },
]
const operator = [
  {
    name: '秒单客单机版',
    dir: 'mdkFile',
    status: 1,
    accept: '.xls,xlsx',
  },
  {
    name: '安娜尔单机云端通用',
    dir: 'anrFile',
    status: 2,
    accept: '.db',
  },
  {
    name: '速推客单机版',
    dir: 'stkFile',
    status: 3,
    accept: '.db',
  },
]
export default {
  components: {
    STable,
    Ellipsis
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      info: null,
      isDone: true,
      operator,
      mdl: {},
      queryParam: {},
      currentRobotId: '',
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      current: 0,
      select: 1,
      list: [],
      transferType: 2,
      params: {
        operator: 1,
        transferType: 1,
        select: 1,
      },
      steps,
      stksteps,
      fileList: [],
      userToken: '',
      // 表头
      columns,
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return DeviceApi.getUploadFileList(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId,
            type: this.params.operator || 1,
            file_type: this.current + 1,
          })
        ).then((res) => {
          this.list = res.data.list
          return {
            data: res.data.list || [],
            pageNo: parameter.pageNo,
            pageSize: parameter.pageSize,
            totalCount: res.data.count,
          }
        })
      },
      selectedRowKeys: [],
      selectedRows: [],
      options: {
        alert: {
          show: true,
          clear: () => {
            this.selectedRowKeys = []
          },
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange,
          getCheckboxProps: (record) => ({
            props: {
              disabled: record.status === 2 || record.status == -1,
              name: record.file_name,
            },
          }),
        },
      },
    }
  },
  computed: {
    type() {
      return operator.find((v) => v.status === this.params.operator)
    },
  },
  watch: {
    list: function () {
      if (!this.list) {
        this.isDone = true
      }
      const obj = this.list.find((v) => {
        return v.status == 0
      })
      // console.log(obj)
      if (obj) {
        this.isDone = true
      } else {
        this.isDone = false
      }
    },
  },
  filters: {
    getItemStatus(status) {
      if (status === 0) {
        return '未开始'
      } else if (status === 1) {
        return '进行中'
      } else if (status === 2) {
        return '已完成'
      } else if (status == '-1') {
        return '失效文件'
      }
    },
  },
  methods: {
    show(info) {
      this.currentRobotId = info.id
      this.info = info
      // console.log(info)
      this.visible = true
      if (this.$refs.table) {
        this.$refs.table.refresh()
      }
    },
    async del(id) {
      const hide = this.$message.loading()
      const res = await DeviceApi.delFile({ id })
      hide()
      if (res.code === 1) {
        this.$message.success('删除成功')
        this.$refs.table.refresh()
      } else {
        this.$message.error(res.msg)
      }
    },
    next() {
      this.current++
      this.params.transferType = this.current + 1
      this.fileList = []
      this.selectedRowKeys = []
      this.selectedRows = []
      this.isDone = true
      this.$refs.table.refresh()
    },
    prev() {
      this.current--
      this.selectedRowKeys = []
      this.selectedRows = []
      this.$refs.table.refresh()
    },
    handleRefresh() {
      this.$refs.table.refresh()
      for (var i in this.list) {
        // console.log(this.list[i].status)
        if (this.list[i].status >= 1) {
          this.isDone = false
        }
      }
    },
    changeParams(type, v) {
      this.params[type] = v
      this.$refs.table.refresh()
    },
    /**
     * 上传文件
     */
    async customRequest({ file, refile }) {
      // console.log(refile)
      const { code, msg } = await DeviceApi.uploadXsl(
        Object.assign(
          {
            sub_id: this.currentRobotId,
            file_url: file,
            file_name: refile.name,
            file_type: this.current + 1,
            type: this.params.operator,
          },
          this.params
        )
      )
      const f = this.fileList.find((v) => {
        if (typeof file === 'string') {
          return refile.uid === v.uid
        }
        return file.uid === v.uid
      })
      if (code === 1) {
        this.$message.success('上传成功')
        this.$refs.table.refresh()
        f.status = 'done'
      } else {
        this.$message.error(msg)
        f.status = 'error'
      }
      return true
    },
    async beforeUpload({ file }) {
      const isLt2M = file.size / 1024 / 1024 < 10
      const obj = this.operator.find((v) => v.status == this.params.operator)
      if (this.params.operator === 1 && !isLt2M) {
        this.$message.error('秒x客最大上传10MB')
        return
      }
      const result = await bigFileUpload(file, obj.dir)
      this.customRequest({ file: result, refile: file })
      // if (!isLt2M) {
      //

      // } else {
      //   this.customRequest({ file, refile:file })
      // }
    },
    handleChange({ fileList }) {
      this.fileList = fileList
      this.$refs.table.refresh()
    },
    handleCancel() {
      this.visible = false
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      // console.log(selectedRowKeys, selectedRows)
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleSubmit() {
      const trans_type = this.params.select

      let ids = this.selectedRows.map((item) => {
        return item.id
      })
      DeviceApi.dataTransfer({ ids, trans_type }).then((res) => {
        if (res.code == 1) {
          this.$message.success(res.msg)
          this.selectedRowKeys = []
          this.selectedRows = []
          this.$refs.table.refresh()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },
}
</script>
<style scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.steps-content {
  /* position: relative; */
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  /* min-height: 200px; */
  /* text-align: center; */
  padding: 10px;
}

.steps-action {
  /* margin-top: 24px; */
  text-align: center;
}
</style>